// Реестр функций захвата изображений для отчёта (Print Report).
//
// Вкладки Map (MapContainer) и Charts (ChartsView) рендерятся через
// <router-view> + <keep-alive>, поэтому вкладка Report — их сосед по дереву и
// не может достучаться до их внутренних инстансов через inject/refs. Чтобы
// получить снимки карты и графиков, каждый компонент-источник регистрирует
// здесь функцию захвата (возвращает dataURL/массив dataURL), пока он
// смонтирован. ReportView вызывает их в момент экспорта.
//
// keep-alive деактивирует соседние вкладки (DOM открепляется), но инстансы
// (OL Map, ECharts) и последний отрендеренный кадр canvas сохраняются —
// живой захват продолжает работать. На случай, если живой захват по какой-то
// причине вернёт пусто, источники дополнительно кладут последний удачный
// снимок в кэш (обычно в хуке deactivated), и runCapture откатывается на него.

const registry = {};
const cache = {};

export function registerCapture(key, fn) {
  registry[key] = fn;
}

export function unregisterCapture(key) {
  delete registry[key];
}

// Положить запасной снимок (например, в момент ухода со вкладки).
export function setCachedCapture(key, value) {
  if (value) cache[key] = value;
}

export function clearCachedCapture(key) {
  delete cache[key];
}

export function getCachedCapture(key) {
  return cache[key] || null;
}

// Есть ли вообще способ получить данные для этого элемента отчёта.
export function hasCapture(key) {
  return !!registry[key] || !!cache[key];
}

// Выполнить захват: сначала живой, при неудаче — кэш.
export async function runCapture(key) {
  if (registry[key]) {
    try {
      const value = await registry[key]();
      if (value && (!Array.isArray(value) || value.length)) return value;
    } catch (err) {
      console.error(`Report capture failed for "${key}":`, err);
    }
  }
  return cache[key] || null;
}
